'use client';

import { useMemo } from 'react';
import { useGreenhouse } from '@/contexts/GreenhouseProvider';
import JobCard from './JobCard';

interface JobListProps {
  featured?: boolean;
  maxJobs?: number;
}

const JobList = ({ featured = false, maxJobs = 20 }: JobListProps) => {
  const { jobs, featuredJobs } = useGreenhouse();

  const displayJobs = useMemo(() => {
    if (!featured) return jobs.slice(0, maxJobs);

    const featuredIds = new Set(featuredJobs.map(j => j.id));
    const nonFeatured = jobs.filter(j => !featuredIds.has(j.id));
    return [...featuredJobs, ...nonFeatured].slice(0, maxJobs);
  }, [featured, maxJobs, jobs, featuredJobs]);

  return (
    <ul className="flex flex-col gap-6">
      {displayJobs.map(job => (
        <li key={job.id}>
          <JobCard job={job} />
        </li>
      ))}
    </ul>
  );
};

export default JobList;
